import { Center, Grid, GridItem, Stack } from "@chakra-ui/react";
import { Form, Options, Show, Stat } from "components";
import { Enums } from "config";
import { useState } from "react";
import { useReport } from "hooks";
import { Moment } from "config";
import TransactionsRealDailyGrowthChart from "./transactionsRealDailyGrowthChart";
import { Mask } from "config";
import WithdrawMonthlyGrowthChart from "./withdrawsMonthlyGrowthChart";
import WithdrawsByStatusBarChart from "./withdrawsByStatusBarChart";
import TransactionsRealXWithdrawsMonthlyGrowthChart from "./transactionsRealXWithdrawsMonthlyGrowthChart";

export default function Financial(){

    const [ period, setPeriod ] = useState(Enums.Period.YEAR)
    const transactions_real_total = useReport('transactions_real_total', period)
    const withdraws_total = useReport('withdraws_total', period)
    const withdraws_total_average = useReport('withdraws_total_average', period)
    const withdraws_x_transactions_real_balance = useReport('withdraws_x_transactions_real_balance', period)
    const [ graph1, setGraph1 ] = useState('transactions_real_daily_growth')

    const periods = Object.keys(Enums.Period).map(item => ({ children: Enums.Period.data(Enums.Period[item]).label, value: Enums.Period[item] }))

    return(
    <>
    <Center mb={12}>
        <Options 
            onChange={setPeriod}
            defaultSelected={period}
            options={periods}
            size="xs"
        />
    </Center>
    
    <Center mb={4}>
        <Form.Select
            w={350}
            size="sm" 
            value={graph1} 
            onChange={e => setGraph1(e.target.value)} 
            options={[{ label: 'Ganho real por período (Diário)', value: 'transactions_real_daily_growth' }, { label: 'Pedidos de saque por período (Mensal)', value: 'withdraws_monthly_growth' }, { label: 'Ganhos Reais x Saques Aprovados (Mensal)', value: 'withdraws_x_transactions_real_monthly_growth' }]} 
        />
    </Center>

    <Show visible={graph1 === 'transactions_real_daily_growth'} children={<TransactionsRealDailyGrowthChart period={period} />} />
    <Show visible={graph1 === 'withdraws_monthly_growth'} children={<WithdrawMonthlyGrowthChart period={period} />} />
    <Show visible={graph1 === 'withdraws_x_transactions_real_monthly_growth'} children={<TransactionsRealXWithdrawsMonthlyGrowthChart period={period} />} />

    <Grid templateColumns="49% 49%" gap={6}>

        <GridItem>

            <Grid templateColumns="49% 49%" gap={4}>
                <GridItem>
                    <Stat.Item
                        loading={transactions_real_total.isLoading}
                        label="Total de ganho real"
                        value={`R$ ${Mask.price(transactions_real_total.data?.data ?? 0)}`}
                        helper={`${Moment(transactions_real_total.data?.metadata?.starts).format('DD/MM/YYYY')} até ${Moment(transactions_real_total.data?.metadata?.ends).format('DD/MM/YYYY')}`} 
                    />
                </GridItem>
                <GridItem>
                    <Stat.Item
                        loading={withdraws_x_transactions_real_balance.isLoading}
                        label="Balanço: ganhos reais x saques aprovados"
                        value={`R$ ${Mask.price(withdraws_x_transactions_real_balance.data?.data ?? 0)}`}
                        helper={`${Moment(withdraws_x_transactions_real_balance.data?.metadata?.starts).format('DD/MM/YYYY')} até ${Moment(withdraws_x_transactions_real_balance.data?.metadata?.ends).format('DD/MM/YYYY')}`} 
                    />
                </GridItem>
            </Grid>

        </GridItem>

        <GridItem>

            <WithdrawsByStatusBarChart period={period} />
            
            <Grid templateColumns="49% 49%" gap={4} mb={6}>

                <GridItem>
                    <Stat.Item
                        loading={withdraws_total.isLoading}
                        label="Total de pedidos de saque"
                        value={`R$ ${Mask.price(withdraws_total.data?.data ?? 0)}`}
                        helper={`${Moment(withdraws_total.data?.metadata?.starts).format('DD/MM/YYYY')} até ${Moment(withdraws_total.data?.metadata?.ends).format('DD/MM/YYYY')}`} 
                    />
                </GridItem>

                <GridItem>
                    <Stat.Item
                        loading={withdraws_total_average.isLoading}
                        label="Média de valor por pedido de saque"
                        value={`R$ ${Mask.price(withdraws_total_average.data?.data ?? 0)}`}
                        helper={`${Moment(withdraws_total_average.data?.metadata?.starts).format('DD/MM/YYYY')} até ${Moment(withdraws_total_average.data?.metadata?.ends).format('DD/MM/YYYY')}`} 
                    />
                </GridItem>
            </Grid>

            


        </GridItem>

    </Grid>

    <Grid templateColumns="33% 33% 33%" gap={6} mt={6}>

        <GridItem>
            
        </GridItem>

        <GridItem>
            
        </GridItem>

        <GridItem>
            
        </GridItem>

    </Grid>
    
    </>
    )
}